import React, { useState } from 'react';
import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import './settings.css';

const Settings = () => {
  const [newPassword, setNewPassword] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const auth = getAuth();

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      setMessage('Password must be at least 6 characters long.');
      return;
    }
    setShowConfirm(true);
  };

  const confirmPasswordUpdate = async () => {
    try {
      const user = auth.currentUser;
      const credential = EmailAuthProvider.credential(
        user.email,
        currentPassword
      );
      
      // First reauthenticate
      await reauthenticateWithCredential(user, credential);
      
      // Then update password
      await updatePassword(user, newPassword);
      
      setMessage('Password updated successfully!');
      setNewPassword('');
      setCurrentPassword('');
      setShowConfirm(false);
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div className="settings-container">
      <h2 className="page-title">Settings</h2>
      <form className="settings-form" onSubmit={handlePasswordUpdate}>
        <div className="form-group">
          <label htmlFor="newPassword" className="form-label">New Password:</label>
          <input 
            type="password" 
            id="newPassword"
            className="form-input" 
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
            required 
          />
        </div>
        <button type="submit" className="settings-button">Update Password</button>
      </form>
      {message && <p className="settings-message">{message}</p>}

      {showConfirm && (
        <div className="delete-modal">
          <div className="delete-modal-content">
            <h3>Confirm Password Change</h3>
            <p>Please enter your current password to confirm the change:</p>
            <input
              type="password"
              className="form-input"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Current password"
            />
            <div className="delete-modal-buttons">
              <button onClick={confirmPasswordUpdate}>Confirm Change</button>
              <button onClick={() => {
                setShowConfirm(false);
                setCurrentPassword('');
              }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Settings;